import { Component, Input, ViewChild } from '@angular/core';
import { IVotePopoverItem } from '../../models/vote-popover-item';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { ViewVoteIconsConstants } from '../../../../../shared/constants/view-vote-icons-constants';
import { materialSymbols } from '../../../../../shared/constants/material-symbols';

@Component({
  selector: 'app-view-votes-popover-ineligible',
  standalone: false,
  templateUrl: './view-votes-popover-ineligible.component.html',
  styleUrl: './view-votes-popover-ineligible.component.scss',
})
export class ViewVotesPopoverIneligibleComponent {
  @ViewChild('viewVotePopoverIneligible') viewVotePopover!: NgbPopover;
  @Input() id: string = 'view-vote-popover-ineligible';
  @Input() votePopoverItems: IVotePopoverItem[] = [];
  @Input() popoverTitle: string = '';

  public readonly ViewVoteIconsConstants = ViewVoteIconsConstants;
  closeSymbol: string = materialSymbols.close;

  public openPopover(): void {
    this.viewVotePopover.open();
  }
}
